import { getDefaultItemPrice } from './get-default-item-price';
export const getDefaultItemPricesForParentSalesOptions = (options) => {
    return options.reduce((prices, option) => {
        prices.push(getDefaultItemPrice(option.prices));
        return prices;
    }, []);
};
